import axios from 'axios'
import FOPForm from '../../../components/checkout/delivery/legal-person-info-forms/FOPForm'
import FiliaForm from '../../../components/checkout/delivery/legal-person-info-forms/FiliaForm'
import OtherForm from '../../../components/checkout/delivery/legal-person-info-forms/OtherForm'

export default {
  state: {
    legalPersonInfo: [],
    isLegalFormValid: false,
    paymentTypes: [],
    payPartsValue: null,
    legalPersonFormComponent: null,
    isPaymentFormEmpty: false,
    monobankRepeatPaymentStatus: null
  },
  getters: {
    isLegalFormValid (state, getters, rootState) {
      if (!rootState.checkout.formData.legalPersonInfo || !rootState.checkout.formData.paymentType) return false

      const { formRef, firmEgr, firmTitle, full_name: organization, phoneNumberForPayment, documentNdsStatus } = rootState.checkout.formData.legalPersonInfo
      const filiaRef = '82a553c6-4f94-11e8-a3de-005056b2fc3d'
      const fopRef = 'd558bfcc-7456-11df-ad52-000c29118aa7'

      const isFiliaFormValid = !!(formRef === filiaRef && firmEgr && firmEgr.length === 8 && firmTitle && documentNdsStatus)
      const isFopFormValid = !!(formRef === fopRef && organization && documentNdsStatus)
      const isOtherFormValid = !!(formRef !== filiaRef && formRef !== fopRef && organization && documentNdsStatus)
      const isValidPhoneNumberForPayment = !!(!phoneNumberForPayment || phoneNumberForPayment.isValid)

      return (isFiliaFormValid || isFopFormValid || isOtherFormValid) && isValidPhoneNumberForPayment
    },
    clientPhone (state, getters, rootState) {
      return rootState.checkout.managersClientData?.phone ?? false
    }
  },
  mutations: {
    SET_LEGAL_PERSON_INFO: (state, data) => {
      state.legalPersonInfo = data
    },
    SET_IS_LEGAL_FORM_VALID: (state, bool) => {
      state.isLegalFormValid = bool
    },
    SET_PAYMENT_TYPES: (state, data) => {
      state.paymentTypes = data
    },
    SET_PAY_PARTS_VALUE: (state, data) => {
      state.payPartsValue = data
    },
    SET_LEGAL_PERSON_FORM_COMPONENT (state, component) {
      state.legalPersonFormComponent = component
    },
    SET_IS_PAYMENT_FORM_EMPTY_WARNING (state, bool) {
      state.isPaymentFormEmpty = bool
    },
    SET_MONOBANK_REPEAT_STATUS (state, bool) {
      state.monobankRepeatPaymentStatus = bool
    }
  },
  actions: {
    SET_IS_PAYMENT_FORM_EMPTY_WARNING: ({ commit }, data) => {
      commit('SET_IS_PAYMENT_FORM_EMPTY_WARNING', data)
    },
    FETCH_LEGAL_PERSON_INFO: ctx => {
      axios
        .get(ctx.rootGetters.urlLanguagePrefix + '/shop/checkout/ownership-types/')
        .then(response => {
          ctx.commit('SET_LEGAL_PERSON_INFO', response.data)
          // ctx.commit('paymentNew/SET_LEGAL_PERSON_INFO', response.data, { root: true })
        })
        .catch(() => ctx.commit('SET_ERROR_FROM_SERVER', ctx.rootGetters.translations('server_error')))
    },
    GET_LEGAL_HISTORY: ctx => {
      axios
        .get(ctx.rootGetters.urlLanguagePrefix + '/shop/checkout/get-legal-history/')
        .then(response => {
          if (!response.data) return
          const {
            edrpou: egr,
            inn,
            vat_payer: pdvStatus,
            company_name: fullName,
            ownership_type_id: formId
          } = response.data

          let legalPersonInfo = {
            formId: formId.toString(),
            egr,
            inn,
            full_name: fullName,
            pdv_status: pdvStatus === 'Y',
            status: 'success'
          }
          if (response.data.short_name) {
            legalPersonInfo = { ...legalPersonInfo, shortName: response.data.short_name }
          }
          const selectedForm = ctx.state.legalPersonInfo.find(el => +el.id === formId)
          ctx.dispatch('SET_LEGAL_PERSON_INFO_COMPONENT_ACTION', selectedForm.ref)
          ctx.commit('REDUCE_FORM_DATA', { legalPersonInfo })
          ctx.commit('paymentNew/SET_LEGAL_PERSON_INFO', legalPersonInfo, { root: true })
        })
        .catch(() => ctx.commit('SET_ERROR_FROM_SERVER', ctx.rootGetters.translations('server_error')))
    },
    FETCH_LEGAL_INFO_BY_CODE: ({ commit, rootGetters, rootState }, data) => {
      const { code, isFilia } = data
      commit('SET_LOADING_COMPONENTS', { legalPersonPayment: true })

      axios
        .get(rootGetters.urlLanguagePrefix + '/shop/cart/legal-info/', { params: { code } })
        .then(response => {
          const { formId, egr, inn, formRef } = rootState.checkout.formData.legalPersonInfo
          let legalPersonInfo = {}
          if (isFilia) {
            legalPersonInfo = { ...rootState.checkout.formData.legalPersonInfo, firmTitle: response.data.full_name, firmEgr: code }
          } else {
            legalPersonInfo = { formId, formRef, inn, egr, ...response.data, documentNdsStatus: '0' }
          }
          if (response.data.short_name) {
            legalPersonInfo = { ...legalPersonInfo, shortName: response.data.short_name }
          }
          commit('REDUCE_FORM_DATA', { legalPersonInfo })
          commit('paymentNew/SET_LEGAL_PERSON_INFO', legalPersonInfo, { root: true })
        })
        .catch(() => commit('SET_ERROR_FROM_SERVER', rootGetters.translations('server_error')))
        .finally(() => commit('SET_LOADING_COMPONENTS', { legalPersonPayment: false }))
    },
    FETCH_PAYMENT_TYPE: (ctx, data) => {
      const params = data ? { ...data } : {}

      ctx.dispatch('SET_LOADING_COMPONENT', { paymentsTypes: true }, { root: true })

      axios
        .get(ctx.rootGetters.urlLanguagePrefix + '/shop/checkout/get-payments/', { params })
        .then(response => ctx.commit('SET_PAYMENT_TYPES', response.data.payments))
        .then(() => ctx.dispatch('FETCH_CART_BONUSES_INFO', { client_phone: ctx.getters.clientPhone }, { root: true }))
        .catch(() => ctx.commit('SET_ERROR_FROM_SERVER', ctx.rootGetters.translations('server_error')))
        .finally(() => ctx.dispatch('SET_LOADING_COMPONENT', { paymentsTypes: false }, { root: true }))
    },
    SET_PAY_PARTS_VALUE_ACTION: (ctx, value) => {
      ctx.commit('SET_PAYMENT_FORM_EMPTY', false)
      ctx.commit('SET_PAY_PARTS_VALUE', value)
    },
    SET_LEGAL_PERSON_INFO_COMPONENT_ACTION ({ commit }, methodId) {
      commit('SET_IS_PAYMENT_FORM_EMPTY_WARNING', false)
      if (!methodId) {
        commit('SET_LEGAL_PERSON_FORM_COMPONENT', null)
        return
      }
      switch (methodId) {
        case 'd558bfcc-7456-11df-ad52-000c29118aa7':
          commit('SET_LEGAL_PERSON_FORM_COMPONENT', FOPForm)
          break
        case '82a553c6-4f94-11e8-a3de-005056b2fc3d':
          commit('SET_LEGAL_PERSON_FORM_COMPONENT', FiliaForm)
          break
        default:
          commit('SET_LEGAL_PERSON_FORM_COMPONENT', OtherForm)
          break
      }
    },
    REPEAT_MONOBANK_PAYMENT ({ rootGetters, commit }, orderId) {
      return new Promise((resolve, reject) => {
        axios
          .get(rootGetters.urlLanguagePrefix + '/shop/checkout/repeat-monobank-payment/', { params: { orderId } })
          .then(res => {
            commit('SET_MONOBANK_REPEAT_STATUS', res.data.status)
            resolve(res.data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    SUBMIT_LIQPAY_FORM_ACTION (ctx, { data, url, signature }) {
      try {
        const liqpayForm = document.createElement('form')
        document.body.appendChild(liqpayForm)
        liqpayForm.method = 'POST'
        liqpayForm.action = url
        liqpayForm.acceptCharset = 'utf-8'
        liqpayForm.innerHTML = `
        <input name='data' type='hidden' value='${data}'>
        <input name='signature' type='hidden' value='${signature}'>
        `
        liqpayForm.submit()
      } catch (error) {}
    },
    SET_DOCUMENT_NDS_STATUS_ACTION ({ commit, rootState }, status) {
      const legalPersonInfo = rootState.checkout?.formData?.legalPersonInfo || {}

      commit('REDUCE_FORM_DATA', { legalPersonInfo: { ...legalPersonInfo, documentNdsStatus: status } })
      commit('paymentNew/SET_LEGAL_PERSON_INFO', { ...legalPersonInfo, documentNdsStatus: status }, { root: true })
    }
  }
}
